import { useState, useEffect } from 'react';

export const useFormData = () => {
  const [locationData, setLocationData] = useState(null);
  const [utmParams, setUtmParams] = useState({});

  useEffect(() => {
    // Capturar parâmetros UTM e fbclid da URL
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};
    
    // Parâmetros UTM
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid'].forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        params[param] = value;
        // Salvar no localStorage para persistir durante a sessão
        localStorage.setItem(param, value);
      } else {
        // Tentar recuperar do localStorage
        const stored = localStorage.getItem(param);
        if (stored) {
          params[param] = stored;
        }
      }
    });
    
    setUtmParams(params);

    // Capturar dados de localização via IP
    const fetchLocationData = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        setLocationData(data);
      } catch (error) {
        console.error('Erro ao capturar dados de localização:', error);
      }
    };

    fetchLocationData();
  }, []);

  const sendToWebhook = async (formData) => {
    const webhookUrl = 'https://n8n.srv693523.hstgr.cloud/webhook/783f5514-1c42-4b8a-ac90-c4baeade643f'; // URL do webhook N8N
    
    const payload = {
      ...formData,
      ...utmParams,
      ip: locationData?.ip,
      city: locationData?.city,
      region: locationData?.region,
      country: locationData?.country_name,
      timezone: locationData?.timezone,
      timestamp: new Date().toISOString(),
      page_url: window.location.href,
      user_agent: navigator.userAgent
    };

    try {
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        mode: 'cors',
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        console.log('Dados enviados com sucesso para o webhook');
        return { success: true };
      } else {
        throw new Error('Erro ao enviar dados para o webhook');
      }
    } catch (error) {
      console.error('Erro ao enviar para webhook:', error);
      return { success: false, error: error.message };
    }
  };

  return {
    locationData,
    utmParams,
    sendToWebhook
  };
};